var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "mb-5" },
      [
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.HEALTH_VARS_SECTION,
              defaultOpened:
                _vm.$route.query.section == _vm.HEALTH_VARS_SECTION,
              overflowVisible: "",
              healthVarsKey: _vm.healthVarsKey,
              title: _vm.$t("healthvariables")
            }
          },
          [
            _vm._l(_vm.basicVariables, function(item, propName) {
              return _c("clinic-history-variable", {
                key: propName,
                staticClass: "mb-2",
                attrs: {
                  rawData: item,
                  name: propName,
                  value: item.values,
                  placeholder: item.placeholder,
                  variableName: item.variableName,
                  editable: _vm.isEditable(propName) && !_vm.historyReadOnly,
                  graphEnabled: _vm.hasGraph(propName)
                },
                on: {
                  updateRawData: function($event) {
                    return _vm.updateRawData($event)
                  }
                }
              })
            }),
            _vm._v(" "),
            !_vm.historyReadOnly
              ? _c(
                  "base-button",
                  {
                    staticClass: "mt-5 mb-3",
                    attrs: { gray: "" },
                    on: { click: _vm.editHealthVars }
                  },
                  [_vm._v(_vm._s(_vm.$t("addOrDeleteHealthvar")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showUpdateActiveVars
              ? _c("history-active-vars", {
                  attrs: { activeVars: _vm.activeVars },
                  on: { activeVarsUpdated: _vm.load }
                })
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        !_vm.$route.query.petId
          ? _c(
              "history-wrapper",
              {
                attrs: {
                  overflowVisible: "",
                  title: _vm.$t("mood"),
                  hideTitleOnOpen: "",
                  hideInnerNeuCardClass: ""
                }
              },
              [_c("history-moods-section")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.$route.query.petId
          ? _c(
              "history-wrapper",
              {
                attrs: {
                  overflowVisible: "",
                  title: _vm.$t("habits"),
                  hideTitleOnOpen: "",
                  hideInnerNeuCardClass: ""
                }
              },
              [_c("history-habits-section")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.$route.query.petId
          ? _c(
              "history-wrapper",
              {
                attrs: {
                  title: _vm.$t("menttum.self-evaluation"),
                  hideViewBtn:
                    !_vm.$store.getters["session/userHasCompanies"] &&
                    !_vm.$store.getters["session/userIsProfessional"],
                  accessBtnUrl:
                    !_vm.historyReadOnly &&
                    _vm.$store.getters["session/userIsPatient"]
                      ? _vm.evaluateHealthUrl
                      : null,
                  sameTab: ""
                }
              },
              [
                _c("self-evaluation-test-diagram", {
                  attrs: { backgroundColor: _vm.WHITE_COLOUR }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.$route.query.petId
          ? _c(
              "history-wrapper",
              {
                attrs: {
                  id: _vm.ADDITIONAL_VARS_SECTION,
                  defaultOpened:
                    _vm.$route.query.section == _vm.ADDITIONAL_VARS_SECTION,
                  title: _vm.$t("howDoYouFeel")
                }
              },
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("clinic-history.in-last-7-days")))
                ]),
                _vm._v(" "),
                _vm._l(_vm.additionalVariables, function(item, propName) {
                  return _c("clinic-history-variable", {
                    key: propName,
                    staticClass: "mb-2",
                    attrs: {
                      rawData: item,
                      name: propName,
                      value: item.values,
                      variableName: item.variableName,
                      editable: !_vm.historyReadOnly,
                      graphEnabled: _vm.hasGraph(propName),
                      slider: "",
                      showGraphByDefault: _vm.variableHasToShowGraphByDefault(
                        propName
                      )
                    }
                  })
                })
              ],
              2
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24d91d24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24d91d24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/ClinicHistoryHealthData.vue
// module id = 3834
// module chunks = 37